module.exports = __webpack_public_path__ + "static/media/C12.cb7e7aa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C12.mp4
// module id = pMRV
// module chunks = 8